<script setup lang="ts">
// nuxt-gtag v4: initialize() was removed; initialization is now automatic via module config
const { gtag } = useGtag()
// gtag('event', 'conversion-test33')



// const { gtag,dataLayer, $script:gtagScript } = useScriptGoogleAnalytics({
//   id: 'G-YMLKKL6MBT'
// })
// gtagScript.then(({gtag})=>{
// gtag('event', 'conversion-test3')
// })
// console.log(gtag)
// gtag('event', 'conversion-test2')
// console.log(dataLayer)

// const { gtag, $script:gtagScript } = useScriptGoogleAnalytics()
// gtag('event', 'conversion-test')

// const googleAnalytics = useScriptTag('https://www.googletagmanager.com/gtag/js?id=G-YMLKKL6MBT', (el) => {
//   window.dataLayer = window.dataLayer || [];
//
//   function gtag() {dataLayer.push(arguments);}
//
//   gtag('js', new Date());
//
//   gtag('config', 'G-YMLKKL6MBT');
// })
// googleAnalytics.load()

</script>

<template>
<div>

</div>
</template>

<style scoped>

</style>